<template>
	<div>
		<CCard v-if="order">
			<CCardHeader>
				<h5>Informations sur la commande</h5>
			</CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="3" class="mb-3"> <span class="font-weight-bold">N° de commande :</span></CCol>
					<CCol col="3" class="mb-3">
						<router-link target="_blank" :to="`/orders/${order.id}/edit`">
							{{ order.id }}
						</router-link>
					</CCol>

					<CCol col="3" class="mb-3">
						<span class="font-weight-bold">Statut de la commande :</span></CCol
					>
					<CCol col="3" class="mb-3">
						<CBadge :color="orderStatusColor[order.status]">{{
							orderStatusTranslation[order.status]
						}}</CBadge>
					</CCol>

					<CCol col="3"> <span class="font-weight-bold">E-mail :</span></CCol>
					<CCol col="3"> {{ order.owner.email }} </CCol>

					<CCol col="3"> <span class="font-weight-bold">Adresse expéditeur :</span></CCol>
					<CCol col="3">
						<span v-if="order.senderAddress.companyName">
							{{ order.senderAddress.companyName }} <br />
						</span>

						<span class="font-weight-bold">
							{{ order.senderAddress.firstName }} {{ order.senderAddress.lastName }} <br />
						</span>

						{{ order.senderAddress.address }} <br />
						<span v-if="order.senderAddress.address2"
							>{{ order.senderAddress.address2 }} <br
						/></span>

						{{ order.senderAddress.city }} {{ order.senderAddress.postalCode }} <br />

						{{ order.senderAddress.country.name }} <br />

						{{ order.senderAddress.phone }}
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard v-if="orderItem">
			<CCardHeader>
				<h5>Informations sur le colis</h5>
			</CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="3" class="mb-3"> <span class="font-weight-bold">N° de colis :</span></CCol>
					<CCol col="3" class="mb-3"> {{ orderItem.id }} </CCol>

					<CCol col="3" class="mb-3"> <span class="font-weight-bold">Statut du colis :</span></CCol>
					<CCol col="3" class="mb-3">
						<CBadge :color="orderItemStateColor[orderItem.state]">
							{{ orderItemStateTranslation[orderItem.state] }}
						</CBadge>
					</CCol>

					<CCol col="3" class="mb-3"> <span class="font-weight-bold">Date livraison :</span></CCol>
					<CCol col="3" class="mb-3" v-if="orderItem.deliveryDate">
						{{ $moment(orderItem.deliveryDate).format('DD/MM/YYYY') }}
					</CCol>
					<CCol col="3" v-else>
						<CIcon name="cil-ban" />
					</CCol>

					<CCol col="3"> <span class="font-weight-bold">Adresse destinataire :</span></CCol>
					<CCol col="3" v-if="orderItem.receiverAddress">
						<span v-if="orderItem.receiverAddress.companyName">
							{{ orderItem.receiverAddress.companyName }} <br />
						</span>

						<span class="font-weight-bold">
							{{ orderItem.receiverAddress.firstName }}
							{{ orderItem.receiverAddress.lastName }} <br />
						</span>

						{{ orderItem.receiverAddress.address }} <br />
						<span v-if="orderItem.receiverAddress.address2"
							>{{ orderItem.receiverAddress.address2 }} <br
						/></span>

						{{ orderItem.receiverAddress.city }} {{ orderItem.receiverAddress.postalCode }} <br />

						{{ orderItem.receiverAddress.country.name }} <br />

						{{ orderItem.receiverAddress.phone }}
					</CCol>
					<CCol col="3" v-else>
						<CIcon name="cil-ban" />
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	export default {
		name: 'selected-package-infos',
		props: {
			order: {
				type: Object,
				default: null,
			},
			orderItem: {
				type: Object,
				default: null,
			},
		},

		data() {
			return {
				orderStatusTranslation: {
					'order.paused': 'En pause',
					'order.in_progress': 'En cours',
					'order.pending': 'En attente',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.paid': 'Payée',
					'order.complete': 'Terminée',
					'order.admin_authorized': 'Autorisation direction',
					'order.payment_issue': 'Erreur de paiement',
					'order.canceled': 'Annulée',
				},
				orderStatusColor: {
					'order.paused': 'warning',
					'order.in_progress': 'info',
					'order.pending': 'warning',
					'order.awaiting_delayed_payment': 'warning',
					'order.paid': 'success',
					'order.admin_authorized': 'success',
					'order.complete': 'success',
					'order.payment_issue': 'danger',
					'order.canceled': 'danger',
					'order.refund': 'warning',
				},
				orderItemStateTranslation: {
					'order_item.pending': 'Étiquette non imprimée',
					'order_item.label_printed': 'Étiquette imprimée',
					'order_item.orphan': 'Colis retirés',
					'order_item.scanned': 'Colis scanné',
					'order_item.paused': 'Colis en pause',
					'order_item.refunded': 'Colis remboursé',
				},
				orderItemStateColor: {
					'order_item.pending': 'danger',
					'order_item.label_printed': 'warning',
					'order_item.orphan': 'warning',
					'order_item.scanned': 'success',
					'order_item.paused': 'danger',
					'order_item.refunded': 'warning',
				},
			};
		},
	};
</script>
